module.exports = {"platforms":[{"message":"start platform","type":"FiniteImmobilePlatform","x":224,"y":416,"width":352,"height":64,"display":{"assetName":"temple"}},{"message":"goal platform","type":"FiniteImmobilePlatform","x":352,"y":96,"width":128,"height":32,"display":{"assetName":"lanterns"}}],"goal":{"x":416,"y":96},"player":{"x":384,"y":352},"par":1}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-t-single-1.json
// module id = 132
// module chunks = 0